import type {V1GuideToApp} from "@khanacademy/embedded-webapp-schema";

import {UXStack} from "./ux-stack.ts";

/**
 * Singleton instance of our UX stack.
 */
let _uxStack: UXStack<V1GuideToApp.Breadcrumb> | void;
/**
 * Accessor to ensure we only create an instance iff we need it.
 */
export function uxStack() {
    _uxStack = _uxStack ?? new UXStack();
    return _uxStack;
}

/**
 * Reset any persistent module state.
 *
 * This is a no-op unless we're in tests. Providing this so that we can
 * tidy-up between tests.
 */
export function reset() {
    if (_uxStack != null) {
        _uxStack.tearDown();
        _uxStack = undefined;
    }
}
